import { render } from "./Quality.vue?vue&type=template&id=61d7f2d0"
import script from "./Quality.vue?vue&type=script&lang=js"
export * from "./Quality.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__